import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import api from '../services/api';
import './VerifyEmail.css';

const VerifyEmail: React.FC = () => {
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
  const [message, setMessage] = useState('');
  const location = useLocation();

  useEffect(() => {
    const token = new URLSearchParams(location.search).get('token');
    if (!token) {
      setStatus('error');
      setMessage('Verification token is missing.');
      return;
    }

    api
      .get(`/auth/verify-email?token=${encodeURIComponent(token)}`)
      .then(() => {
        setStatus('success');
        setMessage('Email verified successfully. You can now log in.');
      })
      .catch(error => {
        setStatus('error');
        setMessage(error.response?.data?.error || 'Verification failed.');
      });
  }, [location.search]);

  return (
    <div className="container verify-email-page">
      <div className={`verify-card ${status}`}>
        <h1>Email Verification</h1>
        <p>{message || 'Verifying your email...'}</p>
        {status !== 'loading' && (
          <Link to="/login" className="btn btn-primary">
            Continue to Login
          </Link>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
